import { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Link } from "react-router-dom";
import routes, { RouteType } from "./route";
import ProtectedRoute from "./ProtectedRoute";
import { RouteErrorBoundary } from "./RouteErrorBoundary";
import { COLORS, ROUTE_PATHS } from "@/constants";
import {
  isRouteDebugEnabled,
  trackNewRelicPageAction,
} from "@/utils/helper/newrelic";

const AppRouteLoading = () => {
  const location = useLocation();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        minHeight: "100dvh",
        color: COLORS.text.pagePrimary,
      }}
    >
      <div>Loading...</div>
      {isRouteDebugEnabled && (
        <div style={{ fontSize: "14px", opacity: 0.75 }}>
          {`Requesting route: ${location.pathname}${location.search}${location.hash}`}
        </div>
      )}
    </div>
  );
};

const RootPathDebugPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isRouteDebugEnabled) return;

    const locationData = {
      href: globalThis.location.href,
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    };

    // eslint-disable-next-line no-console
    console.log("[RootPathDebugPage] Rendered", locationData);
    trackNewRelicPageAction("RootPathRendered", locationData);
  }, [location.hash, location.pathname, location.search]);

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
        color: COLORS.common.white,
        padding: "24px",
        textAlign: "center",
      }}
    >
      <h1 style={{ margin: 0 }}>Root Path Debug</h1>
      <div>{`Current route: ${location.pathname}${location.search}${location.hash}`}</div>
      <div
        style={{ opacity: 0.8 }}
      >{`Full URL: ${globalThis.location.href}`}</div>
      <Link
        to={ROUTE_PATHS.MEMBER.INFORMATION}
        style={{
          color: COLORS.common.white,
          border: `1px solid ${COLORS.common.white}`,
          padding: "10px 16px",
          borderRadius: "8px",
          textDecoration: "none",
        }}
      >
        Go to Member Page
      </Link>
    </div>
  );
};

const AppRoutesContent = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isRouteDebugEnabled) return;

    const locationData = {
      href: globalThis.location.href,
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    };

    // eslint-disable-next-line no-console
    console.log("[AppRoutes] Route requested", locationData);
    trackNewRelicPageAction("RouteRequested", locationData);
  }, [location.hash, location.pathname, location.search]);

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            route.route_type === RouteType.PRIVATE ? (
              <ProtectedRoute>
                <route.component />
              </ProtectedRoute>
            ) : (
              <route.component />
            )
          }
        />
      ))}
      <Route
        path="/"
        element={
          isRouteDebugEnabled ? (
            <RootPathDebugPage />
          ) : (
            <Navigate to={ROUTE_PATHS.MEMBER.INFORMATION} replace />
          )
        }
      />
    </Routes>
  );
};

const AppRoutes = () => (
  <RouteErrorBoundary>
    <Suspense fallback={<AppRouteLoading />}>
      <AppRoutesContent />
    </Suspense>
  </RouteErrorBoundary>
);

export default AppRoutes;
